import {
    YYGL
} from '../constants/funcUrl'

const yyglMutation = {
  [YYGL.APPROVELLIST](state, data) {
    state.approvellist = data;
  },
  [YYGL.ENTERPRISE](state, data) {
    state.enterprise = data;
  },
  [YYGL.ENTERPRISELEARNS](state, data) {
    state.enterpriseLearns = data;
  },
  [YYGL.ENTERPRISETESTS](state, data) {
    state.enterpriseTests = data;
  },
  [YYGL.ENTERPRISEEMPLOYEES](state, data) {
    state.enterpriseEmployees = data;
  },
  [YYGL.ENTERPRISEZJYTESTDETAILS](state, data) {
    state.enterpriseZjyTestDetails = data;
  },
  [YYGL.ENTERPRISEZJYTESTEMPLOYEES](state, data) {
    state.enterpriseZjyTestEmployees = data;
  },
  [YYGL.ENTERPRISEZJYTESTEMPLOYEERECORD](state, data) {
    state.enterpriseZjyTestEmployeeRecord = data;
  },
  [YYGL.ENTERPRISEBDYTESTDETAILS](state, data) {
    state.enterpriseBdyTestDetails = data;
  },
  [YYGL.ENTERPRISEBDYTESTEMPLOYEES](state, data) {
    state.enterpriseBdyTestEmployees = data;
  },
  [YYGL.ENTERPRISEBDYTESTEMPLOYEERECORD](state, data) {
    state.enterpriseBdyTestEmployeeRecord = data;
  },

  [YYGL.ENTERPRISEDETAILS](state, data) {
    state.enterpriseDetails = data;
  },
  [YYGL.ENTERPRISEREGISTER](state, data) {
    state.enterpriseRegister = data;
  },
  [YYGL.ENTERPRISEAPPROVE](state, data) {
    state.enterpriseApprove = data;
  },
  [YYGL.LEARNLEARNAPPROVE](state, data) {
    state.learnApprove = data;
  },
  [YYGL.MAKEUPMAKEUPAPPROVE](state, data) {
    state.makeUpApprove = data;
  },
  [YYGL.PENDINGAPPROVALCOUNT](state, data) {
    state.pendingApprovalCount = data;
  },
  [YYGL.LEARNINGMGTYY](state, data) {
    state.learningmgtYY = data;
  },
  [YYGL.LEARNINGMGT](state, data) {
    state.learningmgt = data;
  },
  [YYGL.LEARNINGMGTEMPLOYEE](state, data) {
    state.learningmgtEmployee = data;
  },
  [YYGL.LEARNINGMGTEMPLOYEEMOCKEXAMRECORDS](state, data) {
    state.learningmgtEmployeeMockExamRecords = data;
  },
  [YYGL.LEARNINGMGTEMPLOYEELESSON](state, data) {
    state.learningmgtEmployeeLesson = data;
  },
  [YYGL.LEARNINGMGTEMPLOYEELESSONS](state, data) {
    state.learningmgtEmployeeLessons = data;
  },
  [YYGL.LEARNINGMGTEMPLOYEELESSONLOG](state, data) {
    state.learningmgtEmployeeLessonLog = data;
  },
  [YYGL.LEARNINGMGTEMPLOYEEFACERECORDS](state, data) {
    state.learningmgtEmployeeFaceRecords = data;
  },
  [YYGL.SEARCHEXPORTEMPLOYEE](state, data) {
    state.temployeeList = data;
  },
  [YYGL.EXPORTEMPLOYEEEXCEL](state, data) {
    state.exportEmployeeExcel = data;
  },
  [YYGL.LEARNAPPROVEEXPORTBDYEXCEL](state, data) {
    state.learnApproveExportBdyExcel = data;
  },
  [YYGL.LEARNAPPROVEEXPORTBDYZPZIP](state, data) {
    state.learnApproveExportBdyZpZip = data;
  },
  [YYGL.LEARNAPPROVEEXPORTBDYHZBEXCEL](state, data) {
    state.learnApproveExportBdyHzbExcel = data;
  },
  [YYGL.LEARNAPPROVEEXPORTJSGREXCEL](state, data) {
    state.learnApproveExportJsgrExcel = data;
  },
  [YYGL.LEARNENTERPRISE](state, data) {
    state.learnEnterprise = data;
  },
  [YYGL.EXPORTEMPLOYEEZP](state, data) {
    state.exportEmployeeZp = data;
  },
  [YYGL.EXPORTBDYEXCEL](state, data) {
    state.exportBdyExcel = data;
  },
  [YYGL.EXPORTJSGREXCEL](state, data) {
    state.exportJsgrExcel = data;
  },
  [YYGL.YYHASCOURSE](state, data) {
    state.yyHasCourse = data;
  },
  [YYGL.LEARNAPPROVEEXPORTEXCEL](state, data) {
    state.learnapproveExportExcel = data;
  },
  [YYGL.LEARNAPPROVEEXPORTEMPLOYEEEXCEL](state, data) {
    state.learnapproveExportEmployeeExcel = data;
  },
  [YYGL.LEARNEXPORTBDYBM](state, data) {
    state.learnBdyBMExcel = data;
  },
  [YYGL.MAKEUPAPPROVEEXPORTAPPROVEEXCEL](state, data) {
    state.exportMakeUpApproveExcel = data;
  },
  [YYGL.MAKEUPAPPROVEEXPORTJFAPPROVEEXCEL](state, data) {
    state.exportMakeUpjfApproveExcel = data;
  },
  [YYGL.TESTMGTROOMS](state, data) {
    state.testRooms = data;
  },
  [YYGL.TESTMGTROOM](state, data) {
    state.testRoom = data;
  },

  [YYGL.TESTMGTBATCHS](state, data) {
    state.testBatchs = data;
  },
  [YYGL.TESTMGTBATCHDETAILS](state, data) {
    state.testBatchDetails = data;
  },
  [YYGL.TESTMGTCOURSEBATCHS](state, data) {
    state.courseTestBatchs = data;
  },
  [YYGL.TESTMGTBATCHEMPLOYEES](state, data) {
    state.testBatchEmployees = data;
  },
  [YYGL.TESTMGTBATCHADDEMPLOYEES](state, data) {
    state.testBatchAddEmployees = data;
  },
  [YYGL.TESTMGTBATCHJOBSTATS](state, data) {
    state.testBatchJobStats = data;
  },
  [YYGL.TESTMGTBATCHEXPORTEMPLOYEEEXCEL](state, data) {
    state.testBatchEmployeeExcel = data;
  },

  [YYGL.TESTMGTTRAINS](state, data) {
    state.testTrains = data;
  },
  [YYGL.TESTMGTCOURSETRAINS](state, data) {
    state.courseTestTrains = data;
  },
  [YYGL.TESTMGTTRAINDETAILS](state, data) {
    state.testTrainDetails = data;
  },
  [YYGL.TESTMGTTRAINEMPLOYEES](state, data) {
    state.testTrainEmployees = data;
  },
  [YYGL.TESTMGTTRAINEXPORTEMPLOYEEEXCEL](state, data) {
    state.testTrainEmployeeExcel = data;
  },
  [YYGL.TESTMGTTRAINEXPORTLESSONEXCEL](state, data) {
    state.testTrainLessonExcel = data;
  },
  [YYGL.TESTMGTTRAINEXPORTEMPLOYEEZP](state, data) {
    state.testTrainEmployeeZp = data;
  },

  [YYGL.TESTMGTSESSIONSTATES](state, data) {
    state.testSessionStates = data;
  },
  [YYGL.TESTMGTSESSIONS](state, data) {
    state.testSessions = data;
  },
  [YYGL.TESTMGTSESSIONDETAILS](state, data) {
    state.testSessionDetails = data;
  },
  [YYGL.TESTMGTSESSIONEMPLOYEES](state, data) {
    state.testSessionEmployees = data;
  },
  [YYGL.TESTMGTSESSIONEMPLOYEEADMISSIONTICKET](state, data) {
    state.testSessionEmployeeAdmissionTicketUrl = data;
  },
  [YYGL.TESTMGTSESSIONADDEMPLOYEES](state, data) {
    state.testSessionAddEmployees = data;
  },
  [YYGL.TESTMGTSESSIONEXPORTEMPLOYEEEXCEL](state, data) {
    state.testSessionEmployeeExcel = data;
  },
  [YYGL.TESTMGTSESSIONEXPORTTESTEXCEL](state, data) {
    state.testSessionTestExcel = data;
  },
  [YYGL.TESTMGTZJPXTRAINS](state, data) {
    state.zjpxTrains = data;
  },

  [YYGL.ZJYTESTMGTBATCHS](state, data) {
    state.zjyTestBatchs = data;
  },
  [YYGL.ZJYTESTMGTBATCHDETAILS](state, data) {
    state.zjyTestBatchDetails = data;
  },
  [YYGL.ZJYTESTMGTBATCHEMPLOYEES](state, data) {
    state.zjyTestBatchEmployees = data;
  },
  [YYGL.ZJYTESTMGTBATCHAPPROVEEMPLOYEES](state, data) {
    state.zjyTestBatchApproveEmployees = data;
  },
  [YYGL.ZJYTESTMGTBATCHAPPROVEEMPLOYEECOUNT](state, data) {
    state.zjyTestBatchApproveEmployeeCount = data;
  },

  [YYGL.ENTERPRISEENTERPRISES](state, data) {
    state.enterprises = data;
  },

  [YYGL.INVOICEAPPROVEYY](state, data) {
    state.invoiceApproves = data;
  },
  [YYGL.INVOICEAPPROVECOUNT](state, data) {
    state.invoiceApproveCount = data;
  },
  [YYGL.INVOICEAPPROVEEXPERTDPWJ](state, data) {
    state.invoiceApproveDpwj = data;
  },
  [YYGL.INVOICEAPPROVEEXPERTDPWJEXCEL](state, data) {
    state.invoiceApproveDpwjExcel = data;
  },

  [YYGL.NEWSTESTPLAN](state, data) {
    state.newsTestPlan = data;
  },
  [YYGL.NEWSTESTPLANTYPES](state, data) {
    state.newsTestPlanTypes = data;
  },

  [YYGL.NEWSCATEGORYS](state, data) {
    state.newsCategorys = data;
  },
  [YYGL.NEWSYY](state, data) {
    state.newsYY = data;
  },

  [YYGL.EMPLOYEES](state, data) {
    state.employees = data;
  },
  [YYGL.EMPLOYEEDETAILS](state, data) {
    state.employeeDetails = data;
  },
  [YYGL.EMPLOYEEMNKSLEARNS](state, data) {
    state.employeeMnksLearns = data;
  },
  [YYGL.EMPLOYEELEARNS](state, data) {
    state.employeeLearns = data;
  },
  [YYGL.EMPLOYEETESTS](state, data) {
    state.employeeTests = data;
  },
  [YYGL.EMPLOYEEPRACTICES](state, data) {
    state.employeePractices = data;
  },

  [YYGL.JSGRTESTMGTBATCHS](state, data) {
    state.jsgrTestBatchs = data;
  },
  [YYGL.JSGRTESTMGTALLBATCHS](state, data) {
    state.allJsgrTestBatchs = data;
  },
  [YYGL.JSGRTESTMGTBATCHJOBSTATS](state, data) {
    state.jsgrTestBatchJobStats = data;
  },
  [YYGL.JSGRTESTMGTBATCHEMPLOYEES](state, data) {
    state.jsgrTestBatchEmployees = data;
  },

  [YYGL.JSGRTESTMGTTRAINS](state, data) {
    state.jsgrTestTrains = data;
  },
  [YYGL.JSGRTESTMGTALLTRAINS](state, data) {
    state.allJsgrTestTrains = data;
  },
  [YYGL.JSGRTESTMGTTRAINEMPLOYEES](state, data) {
    state.jsgrTestTrainEmployees = data;
  },
  [YYGL.JSGRTESTMGTTRAINEMPLOYEEEXPORT](state, data) {
    state.jsgrTestTrainEmployeeExcel = data;
  },
  [YYGL.JSGRTESTMGTTRAINLESSONEXPORT](state, data) {
    state.jsgrTestTrainLessonExcel = data;
  },

  [YYGL.JSGRTESTMGTSESSIONS](state, data) {
    state.jsgrTestSessions = data;
  },
  [YYGL.JSGRTESTMGTSESSIONDETAILS](state, data) {
    state.jsgrTestSessionDetails = data;
  },
  [YYGL.JSGRTESTMGTSESSIONEMPLOYEES](state, data) {
    state.jsgrTestSessionEmployees = data;
  },
  [YYGL.JSGRTESTMGTSESSIONADDEMPLOYEES](state, data) {
    state.addJsgrTestSessionEmployees = data;
  },
  [YYGL.JSGRTESTMGTSESSIONSCOREEXPORT](state, data) {
    state.jsgrTestSessionEmployeeExcel = data;
  },

  [YYGL.TESTMGTPLANBATCHS](state, data) {
    state.bdyTestPlanBatchs = data;
  },
  [YYGL.TESTMGTPLANBATCHJOBSTATS](state, data) {
    state.bdyTestPlanBatchJobStats = data;
  },
  [YYGL.TESTMGTPLANBATCHSESSIONS](state, data) {
    state.bdyTestPlanBatchSessions = data;
  },

  [YYGL.BDYTESTMGTBATCHS](state, data) {
    state.bdyTestBatchs = data;
  },
  [YYGL.BDYTESTMGTBATCHJOBSTATS](state, data) {
    state.bdyTestBatchJobStats = data;
  },
  [YYGL.BDYTESTMGTBATCHDETAILS](state, data) {
    state.bdyTestBatchDetails = data;
  },
  [YYGL.BDYTESTMGTBATCHEEMPLOYEEEXPORT](state, data) {
    state.bdyTestBatchEmployeeExcel = data;
  },

  [YYGL.BDYTESTMGTSESSIONS](state, data) {
    state.bdyTestSessions = data;
  },
  [YYGL.BDYTESTMGTSESSIONJOBSTATS](state, data) {
    state.bdyTestSessionJobStats = data;
  },
  [YYGL.BDYTESTMGTSESSIONDETAILS](state, data) {
    state.bdyTestSessionDetails = data;
  },
  [YYGL.BDYTESTMGTSESSIONEMPLOYEES](state, data) {
    state.bdyTestSessionEmployees = data;
  },
  [YYGL.BDYTESTMGTSESSIONKCYBEXPORT](state, data) {
    state.bdyTestSessionKcybExcel = data;
  },
  [YYGL.BDYTESTMGTSESSIONEMPLOYEEEXPORT](state, data) {
    state.bdyTestSessionEmployeeExcel = data;
  },

  [YYGL.ENTERPRISEMODIFYAPPROVESYY](state, data) {
    state.enterpriseModifyApprovesYY = data;
  },
  [YYGL.ENTERPRISEPENDINGMODIFYAPPROVALCOUNT](state, data) {
    state.pendingModifyApprovalCount = data;
  },

  [YYGL.BDYPRACTICEENROLLS](state, data) {
    state.bdyPracticeEnrolls = data;
  },
  [YYGL.BDYPRACTICEENROLLAPPROVALCOUNT](state, data) {
    state.bdyPracticeEnrollApprovalCount = data;
  },
  [YYGL.BDYPRACTICEENROLLSTATES](state, data) {
    state.gbdyPracticeEnrollStates = data;
  },
  [YYGL.BDYPRACTICEENROLLDETAILS](state, data) {
    state.bdyPracticeEnrollDetails = data;
  },

  [YYGL.QUESTIONQUESTIONS](state, data) {
    state.questionYYs = data;
  },

  [YYGL.QUESTIONBDYQUESTIONS](state, data) {
    state.bdyQuestions = data;
  },

  [YYGL.LEARNINVOICELEARNINVOICES](state, data) {
    state.learnInvoices = data;
  },
  [YYGL.LEARNINVOICEGKDKPCOUNT](state, data) {
    state.learnInvoiceGkDKPCount = data;
  },
  [YYGL.LEARNINVOICEPXDKPCOUNT](state, data) {
    state.learnInvoicePxDKPCount = data;
  },
  [YYGL.LEARNINVOICEDETAILS](state, data) {
    state.learnInvoiceDetails = data;
  },
  [YYGL.LEARNINVOICESTATES](state, data) {
    state.learnInvoiceStates = data;
  },
  [YYGL.LEARNINVOICEEXPERTDPWJ](state, data) {
    state.learnInvoiceDpwj = data;
  },
  [YYGL.LEARNINVOICEEXPERTDPEXCEL](state, data) {
    state.learnInvoiceDpExcel = data;
  }
};

export default yyglMutation;



// WEBPACK FOOTER //
// ./src/store/jzjy/mutations/yyglMutation.js